module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=KN - Saint Kitts and Nevis.a4de5eee.svg";